import React from 'react';
import classes from './Patients.module.css';
import PatientsList from './PatientsList/PatientsList';

const Patients = (props) => {
  return (
    <div>
      <div className={classes.addButton}></div>
      <div>
        <PatientsList patientInfo={props.patientInfo} />
      </div>
    </div>
  );
};
export default Patients;
